<template>
    <section class="LeadsAutoAssigner" v-if="isEnabled">
        <!-- Buttons -->
        <div class="d-flex align-items-center">
            <!-- Grouped Button -->
            <el-button-group>
                <el-button
                    v-if="showSettingsModal"
                    @click="openModal"
                    class="btn-open"
                    :type="startButton.type"
                    icon="el-icon-setting"
                    :disabled="!isEnabled"
                    :size="buttonSize"
                ></el-button>
                <el-button
                    @click="toggleAutoAssignment"
                    class="btn-open"
                    :type="startButton.type"
                    :disabled="!isEnabled"
                    :size="buttonSize"
                >
                    {{ startButton.text }}
                    <i :class="['ml-2', isRunning ? 'el-icon-loading' : 'el-icon-caret-right']"></i>
                </el-button>
            </el-button-group>
        </div>

        <!-- Modal -->
        <x-modal
            v-if="isOpen && showSettingsModal"
            @cancel="isOpen = false"
            @close="isOpen = false"
            @ok="saveAndClose"
            :wWidth="1080"
            :wHeight="windowSize.wHeight"
            :draggable="true"
            :resizable="true"
        >
            <div slot="title" class="d-flex justify-content-between align-items-center">Leads Auto Assigner</div>

            <div>
                <!-- Top Area -->
                <div class="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                        <el-button @click="toggleAutoAssignment" :type="startButton.type">
                            {{ startButton.text }}
                            <i :class="['ml-1', isRunning ? 'el-icon-loading' : 'el-icon-caret-right']"></i>
                        </el-button>
                    </div>
                    <div>
                        <el-button @click="resetSettings" type="danger" v-show="unsaved">Reset</el-button>
                    </div>
                </div>

                <!-- Middle Area -->
                <div class="mb-1 d-flex justify-content-between align-items-center"></div>

                <!-- Tabs -->
                <!-- prettier-ignore -->
                <el-tabs type="border-card" v-loading="loading" v-model="activeTab" @tab-click="onTabClick">
                    <el-tab-pane v-for="(e, i) in tabs" :key="e.name" :label="e.name">
                        <span slot="label"><i :class="e.icon"></i> {{ e.name }}</span>
                        <div v-if="i == activeTab">
                            <component :is="e.component"/>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <div style="height: 100px"></div>
        </x-modal>
    </section>
</template>

<script>
import {mapActions, mapState, mapGetters} from "vuex"
import store from "./store"

import Allocation from "./Allocation"
import Settings from "./Settings"
import History from "./History"

export default {
    name: "LeadsAutoAssigner",
    store,
    components: {
        Allocation,
        Settings,
        History,
    },
    props: {
        buttonSize: {type: String, default: "small"},
    },
    data() {
        return {
            isEnabled: false,
            // isRunning: false,
            isOpen: false,

            showSettingsModal: true,

            tabs: [
                {name: "Settings", component: Settings, icon: "el-icon-setting"},
                {name: "Allocation", component: Allocation, icon: "el-icon-user"},
                // { name: "History", component: History, icon: "el-icon-finished" }
            ],

            activeTab: null,
        }
    },
    computed: {
        ...mapState(["loading", "settings"]),
        ...mapGetters(["unsaved"]),

        isRunning() {
            return _.has(this.settings, "leads_team_auto_assign_running", false)
                ? _.get(this.settings, "leads_team_auto_assign_running", false)
                : _.get(this.settings, "leads_auto_assign_running", false)
        },

        startButton() {
            return {
                text: `${this.isRunning ? "Stop" : "Start"} Auto Assign`,
                type: this.isRunning ? "warning" : "success",
            }
        },

        windowSize() {
            const scaleH = 0.9
            const scaleW = 0.9
            return {wWidth: window.innerWidth * scaleW, wHeight: window.innerHeight * scaleH}
        },
    },
    watch: {},
    mounted() {
        this.isEnabled = parseInt(Ambition.getGlobal("tenant.enable_leads_auto_assign")) === 1

        if (this.isEnabled) {
            this.getSettings()
            this.listenForSockets()
        }
    },
    beforeDestroy() {
        if (this.isEnabled) {
            this.closeSockets()
        }
    },
    updated() {
    },
    activated() {
    },
    methods: {
        ...mapActions([
            "getSettings",
            "listenForSockets",
            "closeSockets",
            "startAutoAssigner",
            "stopAutoAssigner",
            "setSettings",
            "resetSettings",
        ]),

        saveAndClose() {
            this.isOpen = false
            this.$store.dispatch("setSettings")
        },

        openModal() {
            this.isOpen = true
           
        },

        toggleAutoAssignment() {
            if (this.isRunning) {
                this.stopAutoAssigner()
            } else {
                this.startAutoAssigner()
            }
        },

        onTabClick(tab) {

        },
    },
}
</script>

<style lang="scss" scoped>

@keyframes GradientAnimation {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

.LeadsAutoAssigner {
    font-size: 14px;
}

.loading-message {
    font-size: 0.75rem;
}

.btn-open {
}

.btn-gradient-01 {
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background-size: 400% 400%;
    animation: GradientAnimation 10s ease infinite;
    border-color: transparent !important;
}

.btn-gradient-02 {
    background: linear-gradient(-45deg, #63f8da, #0beabd, #09c39e, #06755f);
    background-size: 400% 400%;
    animation: GradientAnimation 10s ease infinite;
    border-color: transparent !important;
}
</style>

<style lang="scss">
.LeadsAutoAssigner {
    .el-tabs--border-card {
        box-shadow: none !important;
    }

    form.el-form {
        .el-form-item {
            margin-bottom: 50px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        label.el-form-item__label {
            height: auto;
            line-height: normal;
            padding: 0 0 4px;
        }

        small {
            line-height: normal;
            margin-bottom: 4px;
        }
    }
}

.LeadsAutoAssignerMessage {
    z-index: 9999 !important;
}
</style>
